<div fxLayout="column" *ngIf="type === 'options'">
    <div fxLayout="row" fxFlex="grow" fxLayoutAlign="start center center" class="modal-header">
        <span fxFlex class="modal-title">Προσθήκη αντικειμένων</span>
        <mat-icon (click)="close()" class="modal-close">close</mat-icon>
    </div>

    <div fxLayout="column" fxFlex="grow" fxLayoutAlign="center center center" style="margin-top:10px;">

        <div fxLayout="row" fxLayoutAlign="start center center" style="margin-top: 10px;" fxLayoutGap="5px">
            <div>Προσθήκη περιγραφής</div>
            <div>
                <mat-form-field>
                    <label>
                        <input matInput [(ngModel)]="newRecordLabel" placeholder="περιγραφή">
                    </label>
                </mat-form-field>
            </div>
            <div>
                <mat-icon (click)="addOption()" style="color: green">add</mat-icon>
            </div>
        </div>

        <div fxLayout="row" *ngIf="options.length > 0" style="width:100%; height: 300px;">
            <mat-table [dataSource]="dataSource" style="width: 100%; overflow: auto;" class="mat-elevation-z1">

                <ng-container matColumnDef="id">
                    <mat-header-cell style="font-family: 'Century Gothic', sans-serif" *matHeaderCellDef
                                     fxLayoutAlign="start center center">Id
                    </mat-header-cell>
                    <mat-cell style="font-family: 'Century Gothic', sans-serif" *matCellDef="let option"
                              fxLayoutAlign="start center center"> {{option.id}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="label">
                    <mat-header-cell style="font-family: 'Century Gothic', sans-serif" *matHeaderCellDef
                                     fxLayoutAlign="center center center">Περιγραφή
                    </mat-header-cell>
                    <mat-cell style="font-family: 'Century Gothic', sans-serif" *matCellDef="let option"
                              fxLayoutAlign="center center center"> {{option.label}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <mat-header-cell style="font-family: 'Century Gothic', sans-serif" *matHeaderCellDef
                                     fxLayoutAlign="center center center">Ενέργειες
                    </mat-header-cell>
                    <mat-cell style="font-family: 'Century Gothic', sans-serif" *matCellDef="let option"
                              fxLayoutAlign="center center center">
                        <mat-icon (click)="deleteOption(option)" style="color: red">delete</mat-icon>
                    </mat-cell>
                </ng-container>


                <mat-header-row *matHeaderRowDef="['id', 'label', 'actions']; sticky: true"></mat-header-row>
                <mat-row *matRowDef="let record; columns: ['id', 'label', 'actions']"></mat-row>
            </mat-table>
        </div>

        <div *ngIf="options.length === 0">
            <div fxLayoutAlign="center center center" style="margin-top: 50px; margin-bottom: 50px;">
                Δεν υπάρχουν επιλογές για προβολή
            </div>
        </div>


        <div fxLayout="row" fxLayoutAlign="center center center" style="margin-top: 10px;">
            <button color="primary" mat-raised-button (click)="close(options)">Αποθήκευση</button>
        </div>
    </div>

</div>


<div fxLayout="column" *ngIf="type === 'label'">
    <div fxLayout="row" fxFlex fxLayoutAlign="start center center" class="modal-header">
        <span fxFlex="grow" class="modal-title">Προσθήκη κειμένου</span>
        <mat-icon (click)="showHideInfo()" class="modal-close">info</mat-icon>
        <mat-icon (click)="close()" class="modal-close">close</mat-icon>
    </div>

    <div fxFlex="grow" fxLayout="row" style="margin-top: 50px;" fxLayoutGap="10px">
        <div fxFlex fxLayout="column" [fxFlex]="showInfo ? 75 : 100">
            <quill-editor (onEditorCreated)="created($event)" #editor [styles]="editorStyle" [(ngModel)]="value"
                                                    placeholder=""
                          style="width:100%; height:600px; min-height: 600px; max-height: 600px;"></quill-editor>
        </div>

        <div fxFlex="40" *ngIf="showInfo" fxLayout="row">
            <div fxLayout="column" fxFlex="grow">

                <div fxLayout="row" style="margin-bottom: 5px;"><label class="modal-title">Πληροφορίες</label></div>

                <div fxLayout="row" style="margin-bottom: 5px;">Μπορείτε να επιλέξετε "δεσμευμένες λέξεις" που θα εισαχθούν μέσα στο κείμενο και θα συμπληρωθούν αυτόματα κατά την παρουσίαση της φόρμας στον χρήστη</div>
                <div fxLayout="row" style="margin-bottom: 5px;">Για εισαγωγή επιλέξτε: </div>

                <div fxLayout="row wrap" fxFlex="grow">
                    <button mat-raised-button style="margin: 10px; background-color: var(--secondaryBlue); color: white;" *ngFor="let tag of defaultMemberTags" (click)="appendToEditor(tag.value)">{{tag.label}}</button>
                </div>

            </div>
        </div>
    </div>
    <div fxLayout="row" fxFlex fxLayoutAlign="center center center">
        <button mat-raised-button (click)="close(value)">Αποθήκευση</button>
    </div>
</div>
